import classes from './LinkButton.module.scss'
import type { ReactElement } from 'react'

export interface BaseProps {
  children: ReactElement<{ href: string }> // The element must have an href
  isDisabled?: boolean
  title?: string
  label?: string
  hasMargin?: boolean
  onClick?: () => void
}
export interface PrimaryProps {
  variant?: 'primary'
  isOutline?: never
  isTransparentBackground?: never
  isFullWidth?: boolean
}
export interface SecondaryProps {
  variant?: 'secondary'
  isOutline?: boolean
  isTransparentBackground?: boolean
  isFullWidth?: boolean
}

type Props = BaseProps & (PrimaryProps | SecondaryProps)

const LinkButton = ({
  children,
  isDisabled = false,
  title,
  label,
  isOutline = true,
  isTransparentBackground = true,
  variant = 'secondary',
  isFullWidth = false,
  hasMargin = true,
  onClick
// eslint-disable-next-line complexity
}: Props) => {
  const disabledStyle = isDisabled
    ? classes.disabled
    : ''

  const outlined = !isOutline
    ? classes.text
    : ''

  const withBackgroundStyle = !isTransparentBackground
    ? classes.withBackground
    : ''

  const fullWidth = isFullWidth
    ? classes.fullWidth
    : ''

  const marginStyle = !hasMargin
    ? classes.noMargin
    : ''

  const linkButtonClassName = [
    classes.LinkButton,
    classes[variant],
    disabledStyle,
    outlined,
    withBackgroundStyle,
    fullWidth,
    marginStyle
  ].filter(style => style).join(' ')

  return (
    <span
      aria-label={label}
      className={linkButtonClassName}
      onClick={onClick}
      title={title}
    >
      {children}
    </span>
  )
}

export default LinkButton